import { render, staticRenderFns } from "./FollowingExportIndex.vue?vue&type=template&id=234fa1dc&"
import script from "./FollowingExportIndex.vue?vue&type=script&lang=js&"
export * from "./FollowingExportIndex.vue?vue&type=script&lang=js&"
import style0 from "./FollowingExportIndex.vue?vue&type=style&index=0&id=234fa1dc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports